import React, { FC } from "react";

import { Icon } from "@/components/Icon";
import { Flex } from "@/eworkitComponents";
import { IConsultantProfileSectionProps } from "@/views/components/ConsultantProfile/Sections/types";
import { Avatar } from "@/views/components/Person/Avatar";

import { AvatarEditButton } from "./AvatarEditButton";

import "./_avatar-section.scss";

interface IAvatarSectionProps extends IConsultantProfileSectionProps {}

export const AvatarSection: FC<IAvatarSectionProps> = ({ onUpdate, record }) => {
  const baseClassName = "avatar-section";

  return (
    <Flex className={baseClassName}>
      <Avatar
        avatar={record.avatar}
        firstName={record.firstName}
        lastName={record.lastName}
        testName="avatarro"
        theme="secondary"
        hjSuppress
      />

      {onUpdate && (
        <Flex className={`${baseClassName}__icon-edit`}>
          <AvatarEditButton
            variant="clean"
            dialogProps={{
              source: record,
              onUpdate,
            }}>
            <Icon color="background-card" icon="edit" size="lg" />
          </AvatarEditButton>
        </Flex>
      )}
    </Flex>
  );
};
